import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {WebhookHeader} from "../../../../core/models/webhook";

@Component({
  selector: 'app-webhook-headertable',
  templateUrl: './webhook-headertable.component.html'
})
export class WebhookHeadertableComponent implements OnInit {

  constructor() {
  }

  @Output() changed: EventEmitter<WebhookHeader[]> = new EventEmitter<WebhookHeader[]>();
  @Input() webRequestHeaders: WebhookHeader[];
  newHeader: WebhookHeader;
  @Input() disabled: boolean;

  ngOnInit() {
    if (this.webRequestHeaders === undefined) {
      this.webRequestHeaders = new Array();
    }
    this.init();
  }

  init() {
    this.newHeader = undefined;
  }

  addNewHeader() {
    this.newHeader = new WebhookHeader();
  }

  deleteNewHeader() {
    this.init();
  }

  saveNewHeader() {
    this.webRequestHeaders.push(this.newHeader);
    this.changed.emit(this.webRequestHeaders);
    this.init();
  }

  deleteHeader(webRequestHeader: WebhookHeader) {
    this.webRequestHeaders = this.webRequestHeaders.filter(parameter => parameter !== webRequestHeader);
    this.changed.emit(this.webRequestHeaders);
  }
}

